import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 13"
}, n = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6 2.586a.625.625 0 0 0-.624.625v.127q.063-.003.125-.003h1q.063 0 .125.003V3.21A.625.625 0 0 0 6 2.586m1.377.865v-.24a1.376 1.376 0 1 0-2.752 0v.24a3.376 3.376 0 0 0-2.5 3.26v3a1.876 1.876 0 0 0 1.876 1.876h4a1.876 1.876 0 0 0 1.876-1.876v-3a3.376 3.376 0 0 0-2.5-3.26M5.5 4.087A2.624 2.624 0 0 0 2.876 6.71v3a1.124 1.124 0 0 0 1.125 1.125h.124V9.21A1.376 1.376 0 0 1 5.5 7.835h1a1.376 1.376 0 0 1 1.376 1.376v1.625h.125A1.124 1.124 0 0 0 9.125 9.71v-3a2.624 2.624 0 0 0-2.624-2.624zm1.624 6.749V9.21a.624.624 0 0 0-.625-.625h-1a.624.624 0 0 0-.624.625v1.625zm-2-5.125c0-.208.168-.376.376-.376h1a.376.376 0 1 1 0 .751h-1a.376.376 0 0 1-.376-.375",
  "clip-rule": "evenodd"
}, null, -1), l = [
  n
];
function r(c, h) {
  return e(), o("svg", a, [...l]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
